import { render, staticRenderFns } from "./GalleryEmptyState.vue?vue&type=template&id=412a4c4b&scoped=true"
import script from "./GalleryEmptyState.vue?vue&type=script&lang=js"
export * from "./GalleryEmptyState.vue?vue&type=script&lang=js"
import style0 from "./GalleryEmptyState.vue?vue&type=style&index=0&id=412a4c4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412a4c4b",
  null
  
)

export default component.exports